import { render, staticRenderFns } from "./dataV.vue?vue&type=template&id=432ba166&scoped=true&"
import script from "./dataV.vue?vue&type=script&lang=js&"
export * from "./dataV.vue?vue&type=script&lang=js&"
import style0 from "./dataV.vue?vue&type=style&index=0&id=432ba166&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432ba166",
  null
  
)

export default component.exports